import styled from 'styled-components'

export const OptionContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-100);
  text-align: left;
`

export const OptionTitle = styled.div`
  font-size: var(--font-size-400);
  font-weight: var(--font-weight-medium);
  line-height: var(--font-line-height-400);
  color: var(--text-primary);
`

export const OptionDescription = styled.div`
  font-size: var(--font-size-300);
  line-height: var(--font-line-height-300);
  color: var(--text-secondary);
  white-space: normal;
`

export const HelperText = styled.div`
  font-size: var(--font-size-300);
  line-height: var(--font-line-height-300);
  color: var(--text-secondary);
  margin-top: var(--space-200);
`
